import React from "react";

export default function ActionsBar({ onSave, onCancel, statePreview }) {
  return (
    <div className="cn-actions">
      <button onClick={onCancel}>Cancel</button>
      <button onClick={onSave}>Save (console)</button>
      <details style={{ marginLeft: 12 }}>
        <summary>State preview</summary>
        <pre>{JSON.stringify(statePreview, null, 2)}</pre>
      </details>
    </div>
  );
}
